'use strict';

var ChartRankingsFilterFactory = function ChartRankingsFilterFactory(DemandFilter, angularHelper) {
  var filtersNamesList = ['MarketsFilterByCabinFactory'];
  var injectedFilters = angularHelper.getProvidersByNames(filtersNamesList);
  function ChartRankingsFilter() {
    DemandFilter.call(this, 'market-dashboard', 'dashboard-rankings');
    this.registerFilters(injectedFilters);
  }
  ChartRankingsFilter.prototype = Object.create(DemandFilter.prototype);
  ChartRankingsFilter.prototype.canFilter = function (sourceType, targetType) {
    return this.sourceType === sourceType && this.targetType === targetType;
  };
  return ChartRankingsFilter;
};
ChartRankingsFilterFactory.$inject = ['DemandFilterFactory', 'AngularHelper'];
module.exports = ChartRankingsFilterFactory;